{
	"end": "{{title}} end",
	"range": "{{title}} range",
	"start": "{{title}} start"
}
